// Enterprise Share Modal Component
import React from 'react';
import type { Warranty, ShareModalState } from '../../types/warranty';
import { shareViaEmail, shareViaWhatsApp, copyToClipboard } from '../../utils/shareUtils';
import '../../styles/components/ShareModal.css';

interface ShareModalProps {
  shareModal: ShareModalState;
  onClose: () => void;
}

export const ShareModal: React.FC<ShareModalProps> = ({ shareModal, onClose }) => {
  if (!shareModal.isOpen || !shareModal.warranty) return null;

  const { warranty } = shareModal;

  const handleEmailShare = () => {
    shareViaEmail(warranty);
    onClose();
  };

  const handleWhatsAppShare = () => {
    shareViaWhatsApp(warranty);
    onClose();
  };

  const handleCopyToClipboard = async () => {
    const success = await copyToClipboard(warranty);
    if (success) {
      onClose();
      // TODO: Add toast notification for success
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Share Warranty Information</h3>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="modal-body">
          <div className="share-warranty-info">
            <h4>{warranty.productName}</h4>
            <p>{warranty.brand} {warranty.modelNumber}</p>
            <p>Expires: {new Date(warranty.warrantyExpiryDate).toLocaleDateString()}</p>
          </div>
          
          <div className="share-options">
            <button 
              className="btn btn-primary share-option"
              onClick={handleEmailShare}
            >
              📧 Email
            </button>
            <button 
              className="btn btn-primary share-option"
              onClick={handleWhatsAppShare}
            >
              💬 WhatsApp
            </button>
            <button 
              className="btn btn-secondary share-option"
              onClick={handleCopyToClipboard}
            >
              📋 Copy
            </button>
          </div>
          
          <div className="share-consent">
            <p><small>📋 Choose what information to share with your consent</small></p>
            <div className="consent-options">
              <label>
                <input type="checkbox" defaultChecked /> 
                Basic info (Product, Brand, Model)
              </label>
              <label>
                <input type="checkbox" defaultChecked /> 
                Warranty dates
              </label>
              <label>
                <input type="checkbox" /> 
                Purchase details
              </label>
              <label>
                <input type="checkbox" /> 
                Provider information
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
